import { useContext } from "react";
import { SupabaseContext, SupabaseContextInterface } from "./supabase-context";

export const useSupabase = (
  context = SupabaseContext
): SupabaseContextInterface => useContext(context) as SupabaseContextInterface;
